let state = {
  icon: null,
};

const getters = {
  GET_SIDEBAR_ICON: state => state.icon,
};
const mutations = {
  RESET_SIDEBAR(state) {
    state.icon = null;
  },
  SET_SIDEBAR_ICON(state, data) {
    state.icon = data;
  },
};

const actions = {
  setSidebarIcon({ commit }, data) {
    commit('SET_SIDEBAR_ICON', data);
  },
  resetSidebar({ commit }) {
    commit('RESET_SIDEBAR');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
